/* THE REVIEWS, CUT TO THREE - the shared copy.
 *
 * Lorenzo, 18 October 2026: "Update the review and faq look up the New - ring code", for
 * the Ring Sizer page. This function used to live in assets/ring-pdp.js, which only the
 * new-ring template loads; it was MOVED here rather than copied, so the ring page and the
 * sizer page cannot drift apart.
 *
 * LOADED BY sections/sesto-fera-reviews-wrapper.liquid, deferred, and only for the
 * templates in the list declared there. Its partner is snippets/sp-reviews-look.liquid,
 * which dresses the classes this puts on; neither is any use without the other.
 *
 * IT STARTS ITSELF when the document is ready, which is all the sizer page needs. On the
 * ring page assets/ring-pdp.js also calls SestoReviews.start() from its own boot, and
 * that second call does nothing: feraReviews marks the band with `spFeraBound` and returns
 * early if it is already bound.
 *
 * NOTHING OF FERA'S IS REWRITTEN. The fourth review onwards is given a class that hides
 * it, Fera's own "Show More" is put out of the way, and one button is added under the
 * third review.
 */
(function () {
  'use strict';

  /* The two helpers the moved function uses, and the only things it needed from
     assets/ring-pdp.js. Four lines, carried rather than imported. */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  // THE REVIEWS, CUT TO THREE (Lorenzo's design, 16 October 2026). The reviews are
  // the Fera app's widget inside sections/sesto-fera-reviews-wrapper.liquid; its
  // markup is NOT rewritten here. The fourth review onwards is given a class that
  // hides it, Fera's own "Show More" is put out of the way, and one button is added
  // under the third review. Press it and everything Fera has already drawn appears,
  // with Fera's own button back underneath to fetch any more - which is the only way
  // to reach the rest, because they are not on the page until Fera asks for them.
  //
  // THE BUTTON SAYS "View more" (Lorenzo, 16 October 2026: "also make view more not
  // view all 1664 reviews"). It used to say "View all N reviews", with N read from
  // the number Fera itself prints; on a ring with no reviews of its own that N is
  // the whole shop's total, 1664, because Fera then shows reviews from across the
  // shop - which is the number he was looking at. No number is read any more. The
  // capitals and the arrow are the stylesheet's doing, as before, and the button
  // still does exactly what it did.
  //
  // IT WAITS FOR FERA AND IT KEEPS UP WITH IT. The widget is drawn by Fera's script
  // some time after this page loads, and redrawn when more reviews are fetched, so
  // this watches the section for changes rather than running once. Every pass does
  // the same thing to the same page, so a pass that changes nothing ends the chain.
  function feraReviews() {
    var KEEP = 3;
    var band = $('.sesto-reviews');
    if (!band || band.spFeraBound) return;
    band.spFeraBound = true;

    var opened = false;
    var waiting = null;

    // PAGES ON A DESKTOP SCREEN, "View more" ON A PHONE (Lorenzo, 19 October 2026:
    // "fix reviews instead of view more make it with paginations so you can go to
    // page 1-2-3-4"). From 769px the reviews Fera has drawn are shown a page at a
    // time - how many to a page is the custom property --sp-rev-per-page in
    // snippets/sp-reviews-look.liquid, 3 unless it says otherwise - with a row of
    // numbered buttons under them and an arrow either side. Fera only draws a
    // handful to begin with and fetches the rest through its own "Show More", which
    // stays hidden here: the right-hand arrow, pressed on the last page that is on
    // the page, presses Fera's button for the customer and moves on to the new page
    // when the new reviews arrive (apply() runs again then, from the observer). The
    // phone keeps the approved three-and-"View more" exactly as it was; nothing below
    // 769px changes, and the same resize listener that re-measures the clamp swaps
    // between the two if a window crosses the line.
    var PER_PAGE = 3;
    var page = 1;
    var advance = false;

    function desktop() {
      return !!(window.matchMedia && window.matchMedia('(min-width: 769px)').matches);
    }
    function perPage() {
      var v = 0;
      try { v = parseInt(window.getComputedStyle(band).getPropertyValue('--sp-rev-per-page'), 10); }
      catch (err) { v = 0; }
      return v > 0 ? v : PER_PAGE;
    }

    // EACH REVIEW'S TEXT, CUT TO TWO LINES, WITH "Read more" UNDER IT (Lorenzo,
    // 16 October 2026: "collapse the text and have a read more button so the
    // entire section takes up less space", asked for the reviews). His design
    // shows a long review as its first two lines and then an underlined
    // "Read more"; a short review shows whole, with no link. How many lines is
    // the CSS custom property --sp-rev-lines in snippets/ring-pdp-styles.liquid,
    // so one number changes both the phone and the desktop.
    //
    // A REVIEW WITH MORE THAN THREE PHOTOGRAPHS ALSO GETS THE LINK, even when its
    // words fit in two lines (Lorenzo, 16 October 2026: "Show max 3 photos but the
    // ability to see more if clicked on read more"). The fourth photograph onwards
    // is hidden by a class the stylesheet acts on, and the link is then the only
    // way to see them, so a review with four photographs and one line of text must
    // have one. Three is written here and in the stylesheet, and the two must agree.
    //
    // ONLY A REVIEW THAT REALLY RUNS PAST THE CLAMP GETS A LINK. The clamp goes
    // on first and then the text is asked how tall it would have been
    // (scrollHeight) against how tall it is now (clientHeight); a short review
    // has the clamp taken straight back off. That measurement needs the text to
    // be ON the page: a review hidden by sp-fera-hidden measures 0 and would
    // look short, so it is left alone until VIEW ALL or Fera's own "Show More"
    // puts it there - this runs again then, from apply(). It is also run again
    // on resize and once the fonts have loaded, because the same words wrap
    // differently at a different width and in a different font.
    //
    // THE CLAMP IS ADDED HERE AND NOWHERE ELSE, so with JavaScript off, or
    // before this runs, every review shows in full. Nothing of Fera's markup is
    // rewritten: the class goes on the text Fera drew and the button is put in
    // beside it.
    var PHOTOS = 3;
    var textCount = 0;

    // THE PICTURE BESIDE EACH NAME (Lorenzo, 16 October 2026: "can you also make
    // the person icon branding consistent and add a verified badge?", then "If we
    // have a photo then show the photo in the icon"). A real photograph of the
    // reviewer stays, in Fera's own round 50px frame. Everything else - Google's
    // coloured circle with a letter in it, in whatever colour Google chose, and
    // Fera's own generated face - is replaced by one thing: the first letter of the
    // name, white on the shop's gold, the gold circle of step 1 in the timeline
    // further up the page. Fera's picture is hidden by the stylesheet, on the class
    // this puts on, never removed, so a redraw cannot leave a hole; its little blue
    // "G" is hidden either way.
    //
    // WHICH IS WHICH IS READ OFF THE PICTURE ITSELF, because both arrive as an
    // <img> from the same address. Fera's own generated face is known by its
    // address; for the rest the picture is drawn into a 16x16 canvas and the
    // colours inside the circle are counted, four bits a channel. Measured on the
    // fifteen reviews loaded at 375 on 16 October 2026: Google's letter circles
    // came to 11, 11, 14, 15, 17 and 17 colours, and real photographs to 55, 58,
    // 60, 62, 62 and 76. Nothing fell between, so the line is at 28.
    //
    // ANYTHING THAT CANNOT BE READ COUNTS AS NO PHOTOGRAPH - no canvas, a picture
    // that will not be read across origins, a picture that does not load - and gets
    // the gold letter. That is the safe way round: the card then looks like the
    // shop rather than broken, and the letter is never wrong.
    var PICTURE_COLOURS = 28;
    var picture = {};

    function lookAtPicture(src) {
      if (!src || picture[src]) return;
      picture[src] = 'letter';
      if (!window.HTMLCanvasElement) return;
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var n = 16;
          var cv = document.createElement('canvas');
          cv.width = n;
          cv.height = n;
          var cx = cv.getContext('2d');
          cx.drawImage(probe, 0, 0, n, n);
          var d = cx.getImageData(0, 0, n, n).data;
          var seen = {};
          var count = 0;
          for (var y = 0; y < n; y++) {
            for (var x = 0; x < n; x++) {
              var dx = x - (n - 1) / 2;
              var dy = y - (n - 1) / 2;
              if (Math.sqrt(dx * dx + dy * dy) > n / 2 - 1) continue;
              var i = (y * n + x) * 4;
              if (d[i + 3] < 40) continue;
              var k = (d[i] >> 4) + ',' + (d[i + 1] >> 4) + ',' + (d[i + 2] >> 4);
              if (!seen[k]) { seen[k] = 1; count++; }
            }
          }
          if (count > PICTURE_COLOURS) {
            picture[src] = 'photo';
            run();
          }
        } catch (e) {}
      };
      probe.src = src;
    }

    function personIcon(item) {
      var col = $('.fera-productReviews-review-customer-avatar-col', item);
      var name = $('.fera-productReviews-review-customer-name', item);
      if (!col || !name) return;

      var shot = $('.fera-productReviews-review-customer-avatar', col);
      var src = shot ? shot.getAttribute('src') : '';
      var real = false;
      if (src && !/people\.pic1\.co/i.test(src)) {
        lookAtPicture(src);
        real = picture[src] === 'photo' && !(shot.complete && shot.naturalWidth === 0);
      }
      if (real) {
        var old = $('.sp-rev-face', col);
        if (old && old.parentNode) old.parentNode.removeChild(old);
        col.classList.remove('sp-rev-face-col');
        return;
      }
      var letter = (name.textContent || '').replace(/^\s+/, '').charAt(0).toUpperCase();
      if (!letter) return;
      var face = $('.sp-rev-face', col);
      if (!face) {
        face = document.createElement('span');
        face.className = 'sp-rev-face';
        // The letter says nothing a screen reader needs: the name is right beside it.
        face.setAttribute('aria-hidden', 'true');
        col.appendChild(face);
      }
      if (face.textContent !== letter) face.textContent = letter;
      col.classList.add('sp-rev-face-col');
    }

    // "Verified buyer", AND ONLY WHERE FERA SAYS SO. Fera's own markup does not
    // carry it: a review in the page is just a data-id and the words. Fera's public
    // reviews endpoint - the same one its widget reads, with the same public key,
    // which this takes from Fera itself rather than writing a key into the theme -
    // answers with a `verified` flag per review, and ids[] asks for exactly the
    // reviews on the page. Measured on 16 October 2026: of 30 reviews loaded on
    // this page, 16 came back verified and 8 not, and the rest were never asked
    // for; so it is a real difference, not a badge for everybody.
    //
    // NOTHING IS SHOWN UNTIL THE ANSWER IS IN, and if the answer never comes - no
    // key, no network, Fera changes the endpoint - no review gets a badge, which is
    // the safe way round: a review wrongly called verified would be a lie to a
    // customer, a review quietly missing its badge is only a badge missing.
    var verified = {};
    var source = {};
    var askedFor = {};

    function feraKey() {
      try {
        return (window.fera && window.fera.api && window.fera.api._config &&
                window.fera.api._config.store_pk) || null;
      } catch (e) { return null; }
    }

    function askVerified(ids) {
      if (!ids.length || !window.fetch) return;
      var key = feraKey();
      if (!key) return;
      var url = 'https://api2.fera.ai/v2/public/reviews.json?public_key=' +
                encodeURIComponent(key) + '&limit=' + ids.length;
      for (var i = 0; i < ids.length; i++) url += '&ids[]=' + encodeURIComponent(ids[i]);
      window.fetch(url, { credentials: 'omit' }).then(function (res) {
        return res && res.ok ? res.json() : null;
      }).then(function (data) {
        if (!data) return;
        var list = [];
        if (Object.prototype.toString.call(data) === '[object Array]') list = data;
        else for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) list.push(data[k]); }
        var changed = false;
        for (var j = 0; j < list.length; j++) {
          var row = list[j];
          if (!row || typeof row.id === 'undefined') continue;
          verified[String(row.id)] = row.verified === true;
          source[String(row.id)] = String(row.original_source || row.channel_code || '').toLowerCase();
          changed = true;
        }
        if (changed) run();
      })['catch'](function () {});
    }

    // ONE LINE UNDER THE NAME, OR NONE. A review Fera marks verified says
    // "Verified buyer"; one it does not, but which it says came from Google, says
    // "Google review" - which is the same thing Fera's own little blue "G" said,
    // from the same field, and is true of that review whether or not Fera can tie
    // it to an order. Never both, and never anything on a review Fera tells us
    // nothing about (Lorenzo, 16 October 2026, said yes to the Google line).
    function markWords(id) {
      if (!Object.prototype.hasOwnProperty.call(verified, String(id))) return '';
      if (verified[String(id)]) return 'Verified buyer';
      if (source[String(id)] === 'google') return 'Google review';
      return '';
    }

    function verifiedMark(item, wanted) {
      var info = $('.fera-productReviews-review-customer-info-col', item);
      if (!info) return;
      var mark = $('.sp-rev-verified', info);
      var id = item.getAttribute('data-id');
      var known = id && Object.prototype.hasOwnProperty.call(verified, String(id));
      var words = id ? markWords(id) : '';
      if (!id || !known || !words) {
        if (!known && id && !askedFor[String(id)]) {
          askedFor[String(id)] = true;
          wanted.push(id);
        }
        if (mark && mark.parentNode) mark.parentNode.removeChild(mark);
        return;
      }
      if (mark) {
        // The words can change under it when a later answer arrives.
        if (mark.lastChild && mark.lastChild.nodeValue !== words) mark.lastChild.nodeValue = words;
        return;
      }
      mark = document.createElement('span');
      mark.className = 'sp-rev-verified';
      mark.innerHTML = '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" ' +
        'focusable="false"><circle cx="8" cy="8" r="6.6" fill="none" stroke="currentColor" ' +
        'stroke-width="1.5"></circle><path d="M4.9 8.2 7 10.3l4.1-4.5" fill="none" ' +
        'stroke="currentColor" stroke-width="1.5" stroke-linecap="round" ' +
        'stroke-linejoin="round"></path></svg>';
      mark.appendChild(document.createTextNode(words));
      info.appendChild(mark);
    }

    // THE STARS AND THE DATE GO INTO THE NAME ROW (Lorenzo, 16 October 2026: "OK to
    // save place can the stars show under the date?", then "the star review put
    // first then the date after"). The card's top becomes one row: the picture and
    // the name at the left, and at the right the five stars with the date under
    // them, both against the card's right edge. The stars stop being a row of their own above the words,
    // which is the height each card saves.
    //
    // THIS ONE IS DONE BY MOVING NODES, not by CSS, and that is not the preference:
    // the stars and the date are inside Fera's content block while the name is a
    // block beside it, and no CSS can lift something out of one box into another.
    // Fera can redraw a review at any time and put them back; this runs again on
    // every change the section makes, from the same watcher as everything else
    // here, and a pass that finds them already moved changes nothing, so the chain
    // ends. Fera's hidden "5" for a screen reader travels inside the stars.
    //
    // ONLY WHERE THE CARD IS A COLUMN. On a desktop Fera lays the card out as a
    // TABLE with the name in a column of its own and the date at the top right of
    // the review, which is what the design shows there, so this puts them back if
    // the card is a table - and the class that dresses the row is put on by this
    // code, never by a width, so the stylesheet and this can never disagree about
    // which layout a card is in. A review that is not on the page is left alone,
    // because a hidden card cannot be asked which layout it is in.
    function headRow(item) {
      var cust = $('.fera-productReviews-review-customer', item);
      var content = $('.fera-productReviews-review-content', item);
      if (!cust || !content || !item.offsetParent) return;
      var stars = $('.fera-productReviews-review-rating', item);
      var date = $('.fera-productReviews-review-date', item);
      var head = $('.sp-rev-head', cust);

      if (getComputedStyle(item).display === 'table') {
        if (!head) return;
        if (stars) content.insertBefore(stars, content.firstChild);
        if (date) content.appendChild(date);
        head.parentNode.removeChild(head);
        cust.classList.remove('sp-rev-head-row');
        return;
      }

      if (!head) {
        head = document.createElement('div');
        head.className = 'sp-rev-head';
        cust.appendChild(head);
      }
      // The stars first and the date under them (Lorenzo, 16 October 2026: "the
      // star review put first then the date after"), and each moved only when it
      // is not already where it belongs, so a pass with nothing to do does nothing.
      if (stars && head.firstChild !== stars) head.insertBefore(stars, head.firstChild);
      if (date && date.parentNode !== head) head.appendChild(date);
      cust.classList.add('sp-rev-head-row');
    }

    function clampOne(item) {
      var body = $('.fera-productReviews-review-body', item);
      if (!body) return;
      var btn = $('.sp-rev-more', item);
      var shelf = $('.fera-review-media', item);
      var manyPhotos = !!shelf && $$('.fera-review-media-item', shelf).length > PHOTOS;

      // Opened by the reader: it stays open, both the words and the photographs,
      // and the link does not come back.
      if (body.spRevOpen) {
        body.classList.remove('sp-rev-clamp');
        if (shelf) shelf.classList.remove('sp-rev-photos-cut');
        if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
        return;
      }

      // The photographs are counted, not measured, so this is right even for a
      // review that is still hidden behind the VIEW MORE button.
      if (shelf) {
        if (manyPhotos) shelf.classList.add('sp-rev-photos-cut');
        else shelf.classList.remove('sp-rev-photos-cut');
      }

      // The words, on the other hand, have to be on the page to be measured: a
      // hidden review would measure 0 and look short.
      var longText = false;
      if (body.offsetParent) {
        body.classList.add('sp-rev-clamp');
        longText = body.scrollHeight - body.clientHeight > 1;
        if (!longText) body.classList.remove('sp-rev-clamp');
      } else {
        longText = body.classList.contains('sp-rev-clamp');
      }

      if (!longText && !manyPhotos) {
        if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
        return;
      }
      if (btn) return;

      textCount++;
      if (!body.id) body.id = 'sp-rev-text-' + textCount;
      var controls = body.id;
      if (manyPhotos) {
        if (!shelf.id) shelf.id = 'sp-rev-photos-' + textCount;
        controls += ' ' + shelf.id;
      }
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sp-rev-more';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', controls);
      btn.addEventListener('click', function () {
        body.spRevOpen = true;
        body.classList.remove('sp-rev-clamp');
        // Looked up again rather than kept from above, because Fera can redraw a
        // review between the link being made and the reader pressing it.
        var shownAgain = $('.fera-review-media', item);
        if (shownAgain) shownAgain.classList.remove('sp-rev-photos-cut');
        btn.setAttribute('aria-expanded', 'true');
        // The link goes away, so the keyboard is left on the text it has just
        // opened - which is also where a screen reader should carry on reading.
        // tabindex -1 lets it take focus without joining the tab order.
        body.setAttribute('tabindex', '-1');
        try { body.focus(); } catch (e) {}
        if (btn.parentNode) btn.parentNode.removeChild(btn);
      });
      // Just under the text, before the photographs and the date, which are left
      // exactly as Fera draws them.
      body.parentNode.insertBefore(btn, body.nextSibling);
    }

    function apply() {
      var widget = $('.fera-productReviews', band);
      if (!widget) return;
      var list = $('.fera-productReviews-reviews', widget);
      if (!list) return;
      var items = $$('.fera-productReviews-review', list);
      if (!items.length) return;

      var more = $('.fera-productReviews-showMore-btn', widget);
      var hasMore = items.length > KEEP || !!more;
      var desk = desktop();
      var per = perPage();
      var pages = Math.max(1, Math.ceil(items.length / per));

      if (desk) {
        // The arrow asked Fera for more and they have come: step on to them.
        if (advance && pages > page) { page += 1; advance = false; }
        if (!more) advance = false;
        if (page > pages) page = pages;
        if (page < 1) page = 1;
        var from = (page - 1) * per;
        var to = page * per;
        for (var d = 0; d < items.length; d++) {
          if (d >= from && d < to) items[d].classList.remove('sp-fera-hidden');
          else items[d].classList.add('sp-fera-hidden');
        }
        // Fera's own footer, with its "Show More", stays out of the way on every
        // page: the arrow does its pressing.
        band.classList.add('sp-fera-cut');
      } else {
        for (var i = 0; i < items.length; i++) {
          if (!opened && i >= KEEP) items[i].classList.add('sp-fera-hidden');
          else items[i].classList.remove('sp-fera-hidden');
        }
        // Not classList.toggle with a second argument: an older phone browser
        // ignores that argument and turns the class ON every time instead.
        if (!opened && hasMore) band.classList.add('sp-fera-cut');
        else band.classList.remove('sp-fera-cut');
      }

      // After the hiding, never before it: a review is measured once it shows.
      var wanted = [];
      for (var k = 0; k < items.length; k++) {
        headRow(items[k]);
        personIcon(items[k]);
        verifiedMark(items[k], wanted);
        clampOne(items[k]);
      }
      askVerified(wanted);

      var box = $('.sp-fera-more', band);
      var pager = $('.sp-fera-pager', band);
      if (desk) {
        if (box) box.parentNode.removeChild(box);
        drawPager(pager, widget, list, pages, more);
        return;
      }
      if (pager) pager.parentNode.removeChild(pager);
      if (opened || !hasMore) {
        if (box) box.parentNode.removeChild(box);
        return;
      }
      if (!box) {
        box = document.createElement('div');
        box.className = 'sp-fera-more';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sp-fera-more__btn';
        btn.appendChild(document.createElement('span'));
        var arrow = document.createElement('span');
        arrow.className = 'sp-fera-more__arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '\u2192';
        btn.appendChild(arrow);
        btn.addEventListener('click', function () {
          opened = true;
          apply();
        });
        box.appendChild(btn);
        (list.parentNode || widget).appendChild(box);
      }
      var words = $('.sp-fera-more__btn span', box);
      if (!words) return;
      if (words.textContent !== 'View more') words.textContent = 'View more';
    }

    // THE ROW OF PAGE BUTTONS. Rebuilt only when what it would say has changed
    // (the signature on the nav), so a pass that changes nothing ends the chain,
    // the same rule as the button above. A number goes to that page; the arrows
    // go one either way, and the right-hand one on the last page presses Fera's
    // hidden "Show More" and marks that the next arrivals are to be shown. Going
    // to a page scrolls the list's top back into view only when it has gone off
    // the top of the window, so a short page under a long one does not leave the
    // customer looking at the footer.
    function drawPager(pager, widget, list, pages, more) {
      if (pages < 2 && !more) {
        if (pager) pager.parentNode.removeChild(pager);
        return;
      }
      if (!pager) {
        pager = document.createElement('nav');
        pager.className = 'sp-fera-pager';
        pager.setAttribute('aria-label', 'Review pages');
        (list.parentNode || widget).appendChild(pager);
      }
      var sig = pages + '/' + page + '/' + (more ? 1 : 0);
      if (pager.getAttribute('data-sp-sig') === sig) return;
      pager.setAttribute('data-sp-sig', sig);
      while (pager.firstChild) pager.removeChild(pager.firstChild);

      function go(n) {
        page = n;
        apply();
        if (list.getBoundingClientRect().top < 0) {
          var y = list.getBoundingClientRect().top + window.pageYOffset - 24;
          try { window.scrollTo({ top: y, behavior: 'smooth' }); }
          catch (err) { window.scrollTo(0, y); }
        }
      }
      function button(text, label, arrow) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sp-fera-pager__btn' + (arrow ? ' sp-fera-pager__arrow' : '');
        b.textContent = text;
        if (label) b.setAttribute('aria-label', label);
        pager.appendChild(b);
        return b;
      }

      var prev = button('‹', 'Previous page', true);
      prev.disabled = page <= 1;
      prev.addEventListener('click', function () { if (page > 1) go(page - 1); });

      for (var n = 1; n <= pages; n++) {
        (function (num) {
          var b = button(String(num), 'Page ' + num, false);
          if (num === page) b.setAttribute('aria-current', 'page');
          else b.addEventListener('click', function () { go(num); });
        }(n));
      }

      var next = button('›', 'Next page', true);
      next.disabled = page >= pages && !more;
      next.addEventListener('click', function () {
        if (page < pages) { go(page + 1); return; }
        if (more) { advance = true; more.click(); }
      });
    }

    var watch = null;
    function run() {
      apply();
      if (watch) watch.takeRecords();
    }
    function soon() {
      if (waiting) clearTimeout(waiting);
      waiting = setTimeout(run, 60);
    }

    if ('MutationObserver' in window) {
      watch = new MutationObserver(soon);
      watch.observe(band, { childList: true, subtree: true });
    }
    // A review can start or stop running past two lines when the window changes
    // width, and the text is a different size until Poppins has loaded, so the
    // measurement is taken again on both.
    var sizing = null;
    window.addEventListener('resize', function () {
      if (sizing) clearTimeout(sizing);
      sizing = setTimeout(run, 150);
    });
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(run);
    }
    // THE 769px LINE ITSELF IS WATCHED TOO, so the swap between pages and "View more"
    // does not depend on a resize event arriving: a viewport emulator was seen to
    // change the width without firing one (20 October 2026).
    if (window.matchMedia) {
      var line = window.matchMedia("(min-width: 769px)");
      if (line.addEventListener) line.addEventListener("change", soon);
      else if (line.addListener) line.addListener(soon);
    }
    run();
  }

  window.SestoReviews = { start: feraReviews };

  /* READY, NOT LOAD. The band is in the markup from the start; Fera fills it later, and
     feraReviews watches the section for that rather than running once. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', feraReviews);
  } else {
    feraReviews();
  }
}());
